import { mainAdminSplitApi } from 'redux/store/mainSplitApi'
import { getSimpleGrade, type QueryParameters, type QueryResult } from 'types'
import { type Rasn, type RasnDetails, type RasnEvent, type RasnEventType } from 'types/RASN'

const rasnApi = mainAdminSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // Partial allows the query parameters to be optional, in which case they
    // are omitted from the request URI (which the backend knows how to handle)
    searchRasns: builder.query<QueryResult<Rasn>, Partial<QueryParameters<Rasn>>>({
      query: (parameters) => {
        return {
          url: '/rasns',
          params: parameters
        }
      },
      providesTags: ['SearchRasns']
    }),
    getRasn: builder.query<RasnDetails, string>({
      query: (rasnNumber) => {
        return {
          url: `/rasns/${rasnNumber}`
        }
      },
      transformResponse (response: RasnDetails): RasnDetails {
        return {
          ...response,
          units: response.units.map((unit) => {
            return {
              ...unit,
              simpleGrade: getSimpleGrade(unit.grade)
            }
          })
        }
      },
      providesTags: (result, error, rasnNumber) => [{ type: 'RasnDetails', id: rasnNumber }]
    }),
    performRasnAction: builder.mutation<void, { rasnNumber: string, action: string }>({
      query: ({ rasnNumber, action }) => {
        return {
          url: `/rasns/${rasnNumber}`,
          method: 'PATCH',
          params: {
            action
          }
        }
      },
      invalidatesTags: (result, error, { rasnNumber }) => [{ type: 'RasnDetails', id: rasnNumber }, { type: 'SearchRasns' }]
    }),
    retriggerRasnEvents: builder.mutation<void, { rasnNumber: string, eventType: RasnEventType }>({
      query: ({ rasnNumber, eventType }) => {
        return {
          url: `/rasns/${rasnNumber}/events/${eventType}`,
          method: 'POST'
        }
      }
    }),
    getRasnEvents: builder.query<RasnEvent[], string>({
      query: (rasnNumber) => {
        return {
          url: `/rasns/${rasnNumber}/events`
        }
      }
    })
  })
})

export const {
  useSearchRasnsQuery,
  useGetRasnQuery,
  useGetRasnEventsQuery,
  usePerformRasnActionMutation,
  useRetriggerRasnEventsMutation
} = rasnApi
